import React, { Component } from 'react';

class IconTicketTotal extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="7" fill="none" viewBox="0 0 20 7">
                <path
                    fill="#1D53A5"
                    d="M17.45 0h-6.803c-1.41 0-2.551 1.404-2.551 3.135 0 1.732 1.142 3.136 2.55 3.136h6.803C18.858 6.27 20 4.867 20 3.135 20 1.404 18.858 0 17.45 0z"
                ></path>
                <path
                    fill="#2E90FC"
                    d="M9.353.053H2.551C1.142.053 0 1.457 0 3.188 0 4.92 1.142 6.324 2.55 6.324h6.803c1.41 0 2.551-1.404 2.551-3.136 0-1.731-1.142-3.135-2.55-3.135z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketTotal;